/* Kept apart from the component so the left rail's query can interpolate it without
 * importing the component that renders it, which would make the two modules' load order
 * decide whether this fragment exists yet.
 */
import { gql } from '@apollo/client';

export const CareTeamClinicianFragment = gql`
    fragment CareTeamClinicianFragment on Clinician {
        id
        firstName
        lastName
        fullName
        email
        employmentType
        isActive
        disciplines {
            id
            code
            displayName
        }
        licenses
    }
`;
